export class Todo {
    constructor(public text: string, public type: string, public isChecked: boolean) {}
}



// WEBPACK FOOTER //
// ./src/app/utils/todo/index.ts